import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=123b9b47&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=123b9b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b9b47",
  null
  
)

export default component.exports